import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { InfoCircleOutlined } from '@ant-design/icons';

import { Label } from './components/Label';
import { CurrencyInput } from './components/CurrencyInput';
import { InputNumberForm } from '../components/FormNumberInput';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import { CustomTooltip } from './styles';
import * as S from '../../styles';

export function Internal() {
	const fieldName: keyof FormData = 'internal';
	const { onKeyDown } = useCalculateReturnOfInvestments();

	return (
		<Row gutter={[0, 35]}>
			<Col span={24} style={{ marginTop: '24px' }}>
				<Row gutter={[16, 20]}>
					<Col xs={24} lg={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							name={[fieldName, 'num_ergonomist']}
							label={I18n.get('Total number of ergonomists')}
							rules={[{ required: true, message: I18n.get('Please enter the number of ergonomists.') }]}
						>
							<InputNumberForm
								min={1}
								style={{ width: '100%' }}
								placeholder={I18n.get('Enter number of ergonomists')}
							/>
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} lg={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							required={false}
							name={[fieldName, 'base_salary_ergonomist']}
							rules={[{ required: true, message: I18n.get('Please enter the base salary.') }]}
							label={
								<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
									<Label label="Base monthly salary per ergonomist" />
									<CustomTooltip
										title={I18n.get('This value will be multiplied by 106% (taxes and fees).')}
									>
										<InfoCircleOutlined style={{ fontSize: '15px', verticalAlign: 'middle' }} />
									</CustomTooltip>
								</div>
							}
						>
							<CurrencyInput placeholder={I18n.get('Enter the base salary')} onKeyDown={onKeyDown} />
						</S.RequiredFormItem>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
